import {
  Box,
  Grid,
  ReassignContactCard,
  Typography,
} from '@atgfr8/atg-ui-tailwind';
import { ReassignTypeEnum } from '@common/types';
import { Popover } from '@components';
import { orderStore } from '@store/orders';
import { ILoadEditViewModel } from '@typeDefinitions/loadTypes';
import ReassignCard from '@views/order/components/reassign/ReassignCard';
import { Show } from 'solid-js';

import { subTextStyle } from '../styles';
import { loadInfoStore } from './store';
import { handleReassignedUser } from './utils';

type PropsT = {
  load: ILoadEditViewModel;
  tabIndex: number;
};

export const CapacityOpsRep = (props: PropsT) => {
  return (
    <div class=" flex bg-[#dfecf2] p-2 rounded-sm max-h-12 min-w-52">
      <Box
        onClick={() => {
          if (props.load.capacityOpsRepUser != null) {
            void handleReassignedUser(
              props.load.capacityOpsRepUserId as number,
              ReassignTypeEnum.CapacityOpsRep,
            );
          }
        }}
      >
        <Show when={props.load.capacityOpsRepUser != null}>
          <Popover
            eleName={
              <div class="text-left">
                <div class="text-[#123b50] font-semibold text-xs">
                  Capacity Ops Rep
                </div>
                <Show
                  when={props.load.capacityOpsRepUser}
                  fallback={
                    <Typography
                      variant="body1"
                      component="div"
                      sxProps={{ textAlign: 'left' }}
                    >
                      -
                    </Typography>
                  }
                >
                  <div class="font-medium">{props.load.capacityOpsRepUser}</div>
                </Show>
              </div>
            }
            sxProps={{
              'text-transform': 'none',
              padding: '0px',
            }}
            class="[&:hover]:bg-none"
          >
            <Box style={{ padding: '8px' }}>
              <ReassignContactCard
                contact={loadInfoStore.capacityOpsRepUser}
                showIcon
                isLoading={loadInfoStore.isLoading}
              />
            </Box>
          </Popover>
        </Show>
        <Show when={props.load.capacityOpsRepUser == null}>
          <Grid item>
            <Typography
              variant="body1"
              component="div"
              sxProps={{ ...subTextStyle, textAlign: 'left' }}
            >
              Capacity Ops Rep
            </Typography>
          </Grid>
          <Grid item size={12}>
            <Typography variant="body1" component="div" class="text-left">
              <Typography
                variant="body1"
                component="div"
                sxProps={{ textAlign: 'left' }}
              >
                -
              </Typography>
            </Typography>
          </Grid>
        </Show>
      </Box>
      <div class="mt-3.5 ml-auto">
        <Show
          when={!orderStore.isReadOnly}
          fallback={
            <Box class=" text-[#026EA1] font-medium text-sm leading-6 tracking-tighter cursor-not-allowed ">
              REASSIGN
            </Box>
          }
        >
          <Popover
            classes="px-1 py-0 !h-[24px]"
            eleName={
              <span class=" text-[#026EA1] font-medium text-sm leading-6 tracking-tighter cursor-pointer ">
                REASSIGN
              </span>
            }
            onClick={() => {
              if (orderStore.isReadOnly) {
                return;
              }

              if (props.load.capacityOpsRepUser != null) {
                void handleReassignedUser(
                  props.load.capacityOpsRepUserId as number,
                  ReassignTypeEnum.CapacityOpsRep,
                );
              }
            }}
          >
            <ReassignCard
              type={'CAPACITY OPS REP'}
              contactInfo={
                props.load.capacityOpsRepUserId != null
                  ? loadInfoStore.capacityOpsRepUser
                  : undefined
              }
              isLoading={() => loadInfoStore.isLoading}
              onButtonClick={handleReassignedUser}
              disabled={orderStore.isReadOnly}
            />
          </Popover>
        </Show>
      </div>
    </div>
  );
};
